import { StyledEtc_CurrentState } from "./style"

const CurrentState = ({isLoading = false, isError = false}) => {
  return (isLoading || isError) ? (
    <StyledEtc_CurrentState className={`CurrentState ${isLoading ? "isLoading" : isError ? "isError" : ""}`}>
      {isLoading ? "로딩중"
      : isError ? "에러"
      : null}
    </StyledEtc_CurrentState>
  ) : null
}

export const Etc = {
  CurrentState
}